var _module_exports = "<detector-rich-form-editor\n  ng-if=\"data\"\n  data=\"data\"\n></detector-rich-form-editor>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/detector/detectorRichFormEditor.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;